import React from 'react';
import { CountdownTimer } from './CountdownTimer';
import { CtaButton } from './CtaButton';
import { ShieldCheck, Zap, CreditCard } from 'lucide-react';
export function FinalCta() {
  return <section className="py-20 px-4 bg-gradient-to-t from-brand/5 to-background border-t border-border" data-id="element-95">
      <div className="max-w-4xl mx-auto text-center" data-id="element-96">
        <h2 className="text-3xl font-heading font-bold text-white mb-6" data-id="element-97">
          ⏰ EL PRECIO CIERRA EN:
        </h2>
        <CountdownTimer className="mb-12" data-id="element-98" />

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-12" data-id="element-99">
          {/* Standard */}
          <div className="bg-surface border border-border rounded-2xl p-6 flex flex-col items-center" data-id="element-100">
            <h3 className="text-xl font-heading font-bold text-white mb-2" data-id="element-101">
              📘 MEGAPACK IA
            </h3>
            <p className="text-sm text-muted mb-4" data-id="element-102">
              6 Tomos + 6 Bonos · Todos los niveles
            </p>
            <div className="flex items-center gap-2 text-danger line-through font-bold mb-1" data-id="element-103">
              $45.000
            </div>
            <div className="text-3xl font-heading font-bold text-white mb-6" data-id="element-104">
              $19.990 ARS
            </div>
            <CtaButton variant="brand" className="w-full py-3 text-base" href="https://www.soportesaberdigital.com/cart/48533295694063:1" data-id="element-105">
              → QUIERO MI MEGAPACK IA
            </CtaButton>
          </div>

          {/* Pro */}
          <div className="bg-surface border-2 border-accent rounded-2xl p-6 flex flex-col items-center relative" data-id="element-106">
            <h3 className="text-xl font-heading font-bold text-white mb-2" data-id="element-107">
              🏆 MEGAPACK IA + AI OS ⭐
            </h3>
            <p className="text-sm text-accent mb-4" data-id="element-108">
              6 Tomos + 6 Bonos + Sistema Operativo de Negocios con IA
            </p>
            <div className="flex items-center gap-2 text-danger line-through font-bold mb-1" data-id="element-109">
              $65.000
            </div>
            <div className="text-3xl font-heading font-bold text-white mb-6" data-id="element-110">
              $27.990 ARS
            </div>
            <CtaButton variant="accent" className="w-full py-3 text-base" href="https://www.soportesaberdigital.com/cart/48535395107055:1" data-id="element-111">
              → QUIERO EL MEGAPACK IA + AI OS
            </CtaButton>
          </div>
        </div>

        <div className="flex flex-wrap justify-center gap-6 text-sm text-muted font-medium" data-id="element-112">
          <span className="flex items-center gap-2" data-id="element-113">
            <ShieldCheck className="text-brand" size={18} data-id="element-114" /> Pago 100% seguro
          </span>
          <span className="flex items-center gap-2" data-id="element-115">
            <Zap className="text-accent" size={18} data-id="element-116" /> Acceso en 5 minutos
          </span>
          <span className="flex items-center gap-2" data-id="element-117">
            <ShieldCheck className="text-brand" size={18} data-id="element-118" /> Garantía 7 días
          </span>
          <span className="flex items-center gap-2" data-id="element-119">
            <CreditCard className="text-blue-400" size={18} data-id="element-120" /> Tarjeta /
            Transferencia / PayPal / Mercado Pago
          </span>
        </div>
      </div>
    </section>;
}